/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p.preview-prod-lev2[_ngcontent-%COMP%]{padding-left:10px}p.preview-prod-lev3[_ngcontent-%COMP%]{padding-left:20px}p.preview-prod-lev4[_ngcontent-%COMP%]{padding-left:30px}.preview-prod[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:10px}p.preview-prod-lev1[_ngcontent-%COMP%]{font-weight:500}.product-preview-container[_ngcontent-%COMP%]{margin:3% 15%}"];
export { styles as styles };
